import { ICustomQueryResult } from "us.collection.admin/interfaces";

export const customQueryResult: ICustomQueryResult = {
  followupHeaders: [],
  followupData: [],
};
